import React, { useEffect, useState, useMemo } from "react";
import { reportUserBehavior } from "../../../../utils/common";
import useQuery from "../../../../hooks/useQuery";
import styles from "./index.module.scss";
import request from "../../../../network/request";
import LoadingHomepage from "../../../maintence/components/LoadingHomepage";
import useGetCh from "../../../../hooks/useGetCh";
import { ErrorPlaceholder } from "../../../../components/placeholder";
import moment from "moment";
import MessageBox from "../../../../components/message-box";
import { useHistory, useLocation } from "react-router-dom";
import {
  SALES_GRAY_STATUS,
  SALES_ORANGE_STATUS,
  SALES_GREEN_STATUS
} from "../../constant";
import { pay } from "../../../../network/api/order";
export default function SettlementDetail() {
  document.title = "订单详情";
  const query = useQuery();
  const salesSettlementCode = query.get("salesSettlementCode");
  const [sales, setSales] = useState<any>(); //外销数据
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // 去开票 invoiceUrl
  const ch = useGetCh();
  let history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    history.listen((pre) => {
      if (location.pathname !== pre.pathname) {
        MessageBox.removeAll();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    getInitOrderList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!isLoading && !isError) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "main_order_list",
          ch,
          pa: `status=success`
        },
        "page"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isError]);

  const getInitOrderList = async () => {
    setIsLoading(true);
    setIsError(false);
    await getSalesDetail(salesSettlementCode);

    setIsLoading(false);
  };

  const getSalesDetail = async (params) => {
    try {
      const res: any = await request(
        "serviceOrder/getFlitOrderDetail",
        { flitReceiptCode: params },
        "POST"
      );
      const data = res;
      setSales(data);
      setIsLoading(false);
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "get_sales_settlement_order_detail_success",
          ch,
          pa: `status=success\`salesSettlementCode=${salesSettlementCode}`
        },
        "event"
      );
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
      setErrorMsg((error as any).message || "加载数据失败，请稍后重试");
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "get_sales_settlement_order_detail_error",
          ch,
          pa: `status=error\`salesSettlementCode=${salesSettlementCode}`
        },
        "event"
      );
    }
  };

  const getOrderPay = async (params) => {
    try {
      const res: any = await pay(params);
      reportUserBehavior({
        so: "J001002",
        mcode: "get_order_pay_success",
        ch,
        pa: `status=success\`balanceCode=${params.balanceCode}\`token=${params.token}\`payment=${params.payment}\`payFromType=${params.payFromType}`
      });
      // MessageBox
      if (res.url) {
        setTimeout(() => {
          window.location.href = res.url;
        }, 300);
      } else if (res.code === 4003) {
        MessageBox.confirm("交易请求已提交，请勿重复支付", {
          showCancelButton: false,
          confirmButtonText: "我知道了"
        }).then(() => {
          window.location.reload();
        });
      } else if (res.code === 4007) {
        MessageBox.confirm("结算内容发生变更，请与服务管家联系", {
          showCancelButton: false,
          confirmButtonText: "确定"
        }).then(() => {
          setTimeout(() => {
            history.push(`/serviceOrders/mainOrderList`);
          }, 300);
        });
      }
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
      setErrorMsg((error as any).message || "加载数据失败，请稍后重试");
      reportUserBehavior({
        so: "J001002",
        mcode: "get_order_pay_error",
        ch,
        pa: `status=error\`balanceCode=${params.balanceCode}\`token=${params.token}\`payment=${params.payment}\`payFromType=${params.payFromType}`
      });
    }
  };

  const handlePay = async () => {
    reportUserBehavior({
      so: "J001002",
      mcode: "settlement_detail_click_toPay",
      ch,
      pa: `event=去支付`
    });

    if (salesSettlementCode) {
      await getOrderPay({
        balanceCode: salesSettlementCode,
        token: sales?.token,
        payment: "cashier",
        payFromType: 1
      });
    }
  };
  const toBilling = (billUrl) => {
    reportUserBehavior({
      so: "J001002",
      mcode: "settlement_detail_click_toBilling",
      ch,
      pa: `event=已支付，去开票`
    });
    setTimeout(() => {
      window.location.href = billUrl;
    }, 300);
  };

  const statusClassName = useMemo(() => {
    const greenList: any[] = SALES_GREEN_STATUS;
    const orangeList: any[] = SALES_ORANGE_STATUS;
    const grayList: any[] = SALES_GRAY_STATUS;
    const status = sales?.orderStatus;

    if (greenList.includes(status)) {
      return styles.greenOrderStatus;
    } else if (orangeList.includes(status)) {
      return styles.orangeOrderStatus;
    } else if (grayList.includes(status)) {
      return styles.grayOrderStatus;
    } else {
      return styles.baseOrderStatus;
    }
  }, [sales]);

  const isCancel = useMemo(() => {
    return sales?.orderStatus === 4;
  }, [sales]);

  if (isLoading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (isError) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "main_order_list",
        ch,
        pa: `status=error`
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={getInitOrderList}
      ></ErrorPlaceholder>
    );
  }

  // 外销结算单详情
  // 订单信息
  const saleOrderInfo = (
    <div className={isCancel ? styles.cancelSaleOrderInfo :styles.saleOrderInfo}>
      <div className={styles.titleWrapper}>
        <span className={styles.title}>精品购买</span>
        <span className={statusClassName}>{sales?.orderStatusText}</span>
      </div>
      <div className={styles.orderMessage}>
        <span className={styles.messageLeft}>服务网点</span>
        <span className={styles.messageRight}>{sales?.shopName}</span>
      </div>
      <div className={styles.orderMessage}>
        <span className={styles.messageLeft}>订单时间</span>
        <span className={styles.messageRight}>
          {moment(sales?.orderTime).format("YYYY/MM/DD HH:mm")}
          {/* {sales?.orderTime} */}
        </span>
      </div>
      <div className={styles.orderMessage}>
        <span className={styles.messageLeft}>车辆</span>
        <span className={styles.messageRight}>{sales?.carLicense}</span>
      </div>
      <div className={styles.orderMessage}>
        <span className={styles.messageLeft}>订单号</span>
        <span className={styles.messageRight}>{sales?.orderCode}</span>
      </div>
    </div>
  );

  // 配件详情(通用)
  const partDetailListInfo = () => {
    if (sales?.partDetailList && sales?.partDetailList.length > 0) {
      return (
        <div className={styles.vehicle}>
          <p className={styles.subTitle}>精品详情</p>
          {sales?.partDetailList.map((item, index) => {
            return (
              <div className={styles.message} key={index}>
                <span className={styles.messageLeft}>
                  <span className={styles.content}>{item.partName}</span>
                  <span className={styles.number}>x {item.partQty}</span>
                </span>
                <span className={styles.messageRight}>
                  ¥ {item.prePartAmount}
                </span>
              </div>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  };

  // 优惠券信息
  const couponInfoList = () => {
    if (sales?.couponInfoList && sales?.couponInfoList.length > 0) {
      return (
        <div className={styles.vehicle}>
          <p className={styles.subTitle}>费用减免</p>
          {sales?.couponInfoList.map((item, index) => {
            return (
              <div key={index} className={styles.couponWrapper}>
                <div className={styles.couponMessage}>
                  <span className={styles.messageLeft}>{item.couponName}</span>
                  <span className={styles.messageRight}>
                    - ¥ {item.cancelAmount}
                  </span>
                </div>
                {item.couponCode && (
                  <div className={styles.couponCode}>
                    <div className={styles.couponTitle}>券号：</div>
                    <div className={styles.codeText}>{item.couponCode}</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  };

  // 支付方式
  const totalAmountInfo = () => {
    if (sales) {
      return (
        <div className={styles.vehicle}>
          <div className={styles.amountMessage}>
            <span className={styles.amountTitle}>合计费用</span>
            <span className={styles.messageRight}>
              ¥ {sales.totalPreAmount}
            </span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };
  // 支付方式
  const payWayInfo = () => {
    if (sales) {
      return (
        <div className={styles.vehicle}>
          <div className={styles.payWayWrapper}>
            <p className={styles.subTitle}>支付方式</p>
            <div className={styles.message}>
              <span className={styles.messageLeft}>
                其他支付方式
                {sales?.notAppPayStatus === 1 ? (
                  <span className={styles.tag}>已支付</span>
                ) : null}
              </span>
              <span className={styles.messageRight}>
                ¥ {sales?.notAppBalanceAmount}
              </span>
            </div>
            <div className={styles.message}>
              <span className={styles.messageLeft}>
                APP内支付
                {sales?.appPayStatus === 1 ? (
                  <span className={styles.tag}>已支付</span>
                ) : null}
              </span>
              <span className={styles.messageRight}>
                ¥ {sales?.appBalanceAmount}
              </span>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  let footerHtml: any = null;
  const footer = () => {
    if (sales) {
      if (sales?.appPayStatus === 0) {
        footerHtml = (
          <div className={styles.payWrapper}>
            <div className={styles.payLeft}>
              <div className={styles.tip}>APP待支付：</div>
              <div className={styles.amount}>¥ {sales?.appBalanceAmount}</div>
            </div>
            <div
              className={styles.payRight}
              onClick={() => {
                handlePay();
              }}
            >
              <div className={styles.toPay}>去支付</div>
            </div>
          </div>
        );
      }
      if (sales?.canApplyInvoice === 1) {
        footerHtml = (
          <div
            className={styles.paidWrapper}
            onClick={() => {
              toBilling(sales?.invoiceUrl);
            }}
          >
            <div className={styles.paid}>
              <span>已支付，去开票</span>
            </div>
          </div>
        );
      }
    }
  };
  footer();

  return (
    <div>
      {/* 施工单 */}
      <div className={styles.detailPageWrapper}>
        {saleOrderInfo}
       <div className={styles.detailPageContent}>
        {!isCancel && partDetailListInfo()}
        {!isCancel && couponInfoList()}
        {!isCancel && totalAmountInfo()}
        {!isCancel && payWayInfo()}
       </div>
        {!isCancel && footerHtml}
      </div>
    </div>
  );
}
